import { create } from 'zustand';

export type TAssignedState<T> = {
  assigned: T[];
  setAssigned: (assigned: T[]) => void;
};

// Create a store with a default generic type (e.g., unknown) to avoid instantiation errors
export const assignStore = create<TAssignedState<any>>((set) => ({
  assigned: [],
  setAssigned: (assigned) => set({ assigned }),
}));

export const useAssigned = <T>() => {
  const assigned = assignStore((state) => state.assigned as T[]);
  const setAssigned = assignStore((state) => state.setAssigned);

  return { assigned, setAssigned };
};
